// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../Core.Generator/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block_video .block__body .block__section_content{background-color:#606060;overflow:hidden;padding-top:56.25%;position:relative;width:100%}.block_video .block__body .block__section_content .block__section_content--player{bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
